@if (contractors()?.length) {
  @for (contractor of contractors(); track contractor.contractor.uuid) {
    <onyx-badge
      color="light-gray"
      (click)="openModal(contractor.contractor); $event.stopPropagation()"
    >
      {{ contractor.contractor.companyProfile.displayName }}

      @if (contractor.gate) {
        ({{ 'labels.gate' | translate | lowercase }} {{ contractor.gate }})
      }
    </onyx-badge>
  }
} @else {
  -
}
